import moment from "moment";
export const isPast = (date, compareDate = new Date()) => {
  return moment(date).isBefore(compareDate);
};
